/**
 * useCustomerData — v1.4.6
 *
 * Was: a stand-alone hook that fetched `/api/customer/dashboard-data`
 * per-component. 16 callers each fired their own fetch on mount, so a
 * single page load could issue 3+ concurrent identical requests (App,
 * TopBar, and the page).
 *
 * Now: a thin wrapper around `CustomerDataContext`. ALL 16 consumers
 * share a single fetch served by `CustomerDataProvider`. The public
 * shape (`{customerData, dataAvailable, isLoading, error,
 * isActiveCustomer, customer, companyName, reload}`) is unchanged, so
 * no consumer needs an edit.
 *
 * See `CustomerDataProvider.jsx` for the actual fetch + caching logic
 * and the graceful-degradation contract.
 */
import { useCustomerDataContext } from "./CustomerDataProvider";

export default function useCustomerData() {
  return useCustomerDataContext();
}
